export default __webpack_public_path__ + "6f1cd8d976bcb191ddfe28682257f8b3.png";